<aura-edit-wrapper
  title="Spécialités de transactions"
  [(isEditing)]="isEditing"
  [isAllowedToEdit]="isAllowedToEdit()"
  [showDivider]="true"
  (saved)="onSave($event)"
  #editWrapper="auraEditWrapper"
>
  @if (editWrapper.isEditing()) {
    <etxe-agent-specialties-form
      [specialties]="currentSpecialties()"
      (validityChanged)="editWrapper.onValidityChanged($event)"
      (dtoChanged)="editWrapper.onDtoChanged($event)"
    />
  } @else {
    <etxe-agent-specialties-display [specialties]="currentSpecialties()" />
  }
</aura-edit-wrapper>
